
import { Alert, Box, Button, Divider, Stack, Toolbar, Typography } from "@mui/material";
import Search from "./Search";

import { useNavigate, useSearchParams } from "react-router-dom";
import { Suspense, useEffect, useState } from "react";
import { toast } from "../../components/Toast";
import AppSidebar from "../../components/AppSidebar/AppSidebar";
import PageLoader from "../../components/PageLoader";
import { useStore } from "../../store";
import { formatDuration, getTickLabels } from "../../utils/utils";
import Span from "./Span";
import dayjs from "dayjs";
import traceService from "../../services/trace.service";


function Traces(): JSX.Element {

	const [searchParams] = useSearchParams();
	const [requestId, setRequestId] = useState(searchParams.get('requestId') || "");
	const navigate = useNavigate()
	const { dispatch } = useStore();
	const [loading, setLoading] = useState(false)
	const [traces, setTraces] = useState<any>(null);
	const [parentSpan, setParentSpan] = useState<any>(null)
	const getTraceList = async (requestId: any) => {
		if (!requestId)
			return
		try {
			setLoading(true)
			const resp = await traceService.getTraces(requestId);
			setTraces(resp?.data || [])
			const parentSpan = resp?.data?.length > 0 ? resp?.data[0] : null
			setParentSpan(parentSpan)
		} catch (error: any) {
			console.error("e", error)
			toast.error(dispatch, error?.response?.data?.message || 'Something went wrong')
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (requestId)
			getTraceList(requestId);
	}, [searchParams]);


	const onFindTrace = (values: any) => {
		setRequestId(values?.requestId)
		getTraceList(values?.requestId);
	}

	const onViewLogClick = () => {
		if (traces?.length > 0) {
			const startTime = new Date(traces[0]?.Timestamp).getTime();
			const endTime = startTime + (traces[0]?.Duration / 1000000);
			navigate(`/logs?requestId=${requestId}&startTime=${startTime}&endTime=${endTime}`)
		}
		else {
			toast.error(dispatch, "No spans")
		}
	}

	const tickLabels = getTickLabels(traces || []);
	return (
		<Box sx={{ display: "flex" }}>
			<AppSidebar />
			<Box style={{ width: "100%" }}>
				<Toolbar
					sx={{ borderBottom: "1px solid #cdcdcd", paddingY: "10px", gap: "2%", display: "flex", justifyContent: "space-between" }}
					variant="dense"
				>
					<Typography variant="h6">Traces</Typography>
					<Box ml="auto">
						<Button variant="contained" onClick={onViewLogClick} disabled={!traces?.length}>View Logs</Button>
					</Box>
				</Toolbar>

				<Suspense fallback={<PageLoader />}>
					<Box display="flex" padding={3} flexDirection={"column"}>
						<Search filters={{ requestId }} onFindTrace={onFindTrace} />
						{traces?.length === 0 && !loading && <Box py={2}><Alert severity="info">No Traces Found!</Alert></Box>}
						{traces?.length > 0 && <><Box bgcolor="#f39540ad" py={0.75} px={2} mt={1}>
							<Stack direction="row" width="100%" spacing={2} divider={<Divider orientation="vertical" sx={{ height: 16, borderColor: '#000' }} />}>
								<Box display="flex">
									<Typography >Trace start</Typography>
									<Typography fontWeight={600} ml={1}>{dayjs(parentSpan?.timestamp).toString()}</Typography>
								</Box>
								<Box display="flex">
									<Typography >Duration</Typography>
									<Typography fontWeight={600} ml={1}>{traces?.length > 0 ? formatDuration(traces[0].Duration) : 0}</Typography>
								</Box>
								<Box display="flex">
									<Typography >Total Spans</Typography>
									<Typography fontWeight={600} ml={1}>{traces?.length}</Typography>
								</Box>
							</Stack>
						</Box>
							<Box className="timeline-header" display="flex" bgcolor="grey.300" >
								<Box width={320} py={1.5} paddingX={2} >
									<Typography fontWeight={600}>Service & Operation</Typography>
								</Box>
								<Box flexGrow={1} position="relative" py={1.5}>
									{tickLabels.map((tick: any, index: number) =>
										<Box position="absolute" top={0} height="100%" borderLeft={1} borderColor="grey.400" left={`${tick.portion * 100}%`}>
											<Typography position="absolute" noWrap top={'50%'} left={index === tickLabels?.length - 1 ? tick?.label?.length > 8 ? "-100px" : "-75px" : 0} >{tick.label}</Typography>
										</Box>
									)}
								</Box>
							</Box>
							{
								traces?.map((span: any, index: number) => <Span span={span} ticks={tickLabels} index={index} totalDuration={traces[0]?.Duration} startTime={traces[0]?.Timestamp} />)
							}
						</>
						}
					</Box>
				</Suspense>
			</Box>
		</Box>
	);
}

export default Traces;
